import ApiCore from "./api_core"
import { DistrictI, LocationI, RegionI, TAI, VillageI } from "./types"

export default new class {
    getCurrentFacility() {
        return ApiCore.getJson<LocationI>('locations/current_facility')
    }

    getFacilities(params={} as Record<string, string | number>) {
        return ApiCore.getJson<LocationI[]>('locations', params)
    }

    getFacility(locationID: number) {
        return ApiCore.getJson<LocationI>(`locations/${locationID}`)
    }

    getRegions() { 
        return ApiCore.getJson<RegionI[]>('regions') 
    }

    getDistricts(regionID: number) {
        return ApiCore.getJson<DistrictI[]>('districts', {region_id: regionID, page_size: 1000})
    }

    getTraditionalAuthorities(districtID: number, name='') {
        return ApiCore.getJson<TAI[]>('traditional_authorities', { district_id: districtID, name })
    }

    getVillages(traditionalAuthorityID: number, name='') {
        return ApiCore.getJson<VillageI[]>('villages', { traditional_authority_id : traditionalAuthorityID, name})
    }

    createAddress(locationName: string, type: 'Village' | 'TA', parentLocationID: number) {
        return ApiCore.postJson<Record<'name', string>>('addresses', {
            address_type: type,
            addresses_name: locationName,
            parent_location: parentLocationID
        })
    }

    async getDistrictByID(id: number) {
        const res = await ApiCore.getJson<DistrictI>('/districts', {'district_id': id})
        if(res.ok && res.data) return res.data
        throw new Error(res.errorMessage)
    }

    async getTraditionalAuthorityById(id: number | string) {
        const res = await ApiCore.getJson<TAI[]>('/traditional_authorities', { 'traditional_authority_id': id}) 
        if (res.ok && res.data) return res.data[0];
        throw new Error(res.errorMessage);
    }
}
